import type {
  CrmAccountFilters,
  CrmInboxScope,
} from "@/nango/types/apps.autoleads/autoleads/Crm"

// One root for the whole global CRM, so a write anywhere (a task closed, an
// activity logged) can refresh every surface that counts the same work.
export const crmKeys = {
  all: ["autoleads", "crm"] as const,
  meta: (team: number) => [...crmKeys.all, "meta", team] as const,
  accounts: (team: number, filters: CrmAccountFilters) =>
    [...crmKeys.all, "accounts", team, filters] as const,
  account: (accountId: number) =>
    [...crmKeys.all, "account", accountId] as const,
  timeline: (accountId: number) =>
    [...crmKeys.all, "timeline", accountId] as const,
  inbox: (
    team: number,
    scope: CrmInboxScope,
    done: boolean,
    search: string,
    page: number,
  ) => [...crmKeys.all, "inbox", team, scope, done, search, page] as const,
  counts: (team: number) => [...crmKeys.all, "counts", team] as const,
  duplicates: (team: number, page: number) =>
    [...crmKeys.all, "duplicates", team, page] as const,
  manualProgress: (team: number) =>
    [...crmKeys.all, "manual-progress", team] as const,
  manualDuplicates: (team: number, fingerprint: string) =>
    [...crmKeys.all, "manual-duplicates", team, fingerprint] as const,
  meetings: (team: number, page: number, search: string) =>
    [...crmKeys.all, "meetings", team, page, search] as const,
  meeting: (meetingId: number) =>
    [...crmKeys.all, "meeting", meetingId] as const,
  meetingMedia: (meetingId: number) =>
    [...crmKeys.all, "meeting-media", meetingId] as const,
}
